import BenefitConsumableSelect from '@/components/_common/BenefitConsumableSelect';
import { BenefitConsumable } from '@/core/domain/operational/benefits-consumable/benefits-consumable.types';

interface Props {
  serviceCode: number;
  onChange(material: BenefitConsumable | undefined): void;
  disableMaterialIds: number[];
  disabled?: boolean;
}

export default function BenefitMaterialSelect(props: Props) {
  return (
    <BenefitConsumableSelect
      value={null}
      queryFilter={{ serviceCode: String(props.serviceCode) }}
      onConsumableSelected={props.onChange}
      placeholder="Selecionar material"
      disableValues={props.disableMaterialIds}
      disabled={props.disabled}
    />
  );
}
